import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FolderZip from "@mui/icons-material/FolderZip";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { getMediaType, MediaType } from "utils/mediaUtils";

const DefaultMedia = ({ contentType }: { contentType: string }) => {
  const style = { display: "block", width: "200px", height: "200px" };
  const mediaType = getMediaType(contentType);

  switch (mediaType) {
    case MediaType.DOCUMENT:
      return <DescriptionOutlinedIcon style={style} />;
    case MediaType.AUDIO:
      return <VolumeUpIcon style={style} />;
    case MediaType.VIDEO:
      return <PlayCircleOutlineIcon style={style} />;
    case MediaType.ARCHIVE:
      return <FolderZip style={style} />;
    default:
      return null;
  }
};

export default DefaultMedia;
